import { motion, useAnimation } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';

interface RefreshIconProps extends React.SVGProps<SVGSVGElement> {
  spin?: boolean;
}

const StyleRefreshIcon = styled.div`
  color: var(--pcm-body-color-secondary);
  width: 20px;
  min-width: 20px;
  display: flex;
  align-items: center;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: var(--pcm-body-color);
    }
  }
`;

export const RefreshIcon: React.FC<RefreshIconProps> = ({ spin, ...props }) => {
  const controls = useAnimation();
  const [isSpinning, setIsSpinning] = useState(false);
  useEffect(() => {
    let animation;

    const startSpinning = async () => {
      if (isSpinning) {
        animation = await controls.start({
          rotate: [0, 360],
          transition: { repeat: Infinity, duration: 1, ease: 'linear' },
        });
      }
    };

    if (spin) {
      setIsSpinning(true);
      startSpinning();
    } else {
      setIsSpinning(false);
      controls.stop();
    }

    return () => {
      if (animation) {
        animation.stop();
      }
    };
  }, [spin, controls, isSpinning]);

  return (
    <StyleRefreshIcon>
      <motion.svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...(props as any)}
        animate={controls}
      >
        <path
          d='M18.6187 5.63377C18.3947 5.52181 18.0589 5.63377 17.9469 5.96963L17.4991 7.20111C16.8274 5.52181 15.8198 4.17837 14.2525 3.28275C12.3493 2.16321 10.2221 1.7154 8.09503 2.27517C5.07229 2.94689 2.83323 5.18595 2.04955 8.20869C1.9376 8.54455 2.16151 8.76846 2.38541 8.88041C2.72127 8.88041 2.94518 8.76846 3.05713 8.4326C3.72885 5.74572 5.74401 3.73056 8.43089 3.17079C10.3341 2.72298 12.2373 3.05884 13.8047 4.06642C15.1481 4.85009 16.1557 6.08158 16.7154 7.53697L15.372 6.97721C15.1481 6.86525 14.8122 6.97721 14.7003 7.31307C14.5883 7.53697 14.7003 7.87283 14.9242 7.98479L17.1633 8.88041C17.2752 8.99237 17.3872 8.99237 17.4991 8.99237H17.6111C17.6111 8.99237 17.6111 8.99237 17.723 8.99237C17.835 8.99237 17.9469 8.88041 17.9469 8.76846L18.9545 6.19353C19.0665 5.96963 18.8426 5.74572 18.6187 5.63377Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='0.3'
        />
        <path
          d='M17.6111 11.1195C17.3872 11.0076 17.0513 11.2315 17.0513 11.4554C16.3796 14.1423 14.3644 16.1574 11.6776 16.7172C9.77434 17.165 7.87114 16.8291 6.30379 15.8216C4.96035 15.0379 3.95277 13.8064 3.393 12.351L4.73644 12.9108C4.96035 13.0227 5.29621 12.9108 5.40816 12.5749C5.52012 12.351 5.40816 12.0151 5.18426 11.9032L2.83324 11.1195C2.72128 11.1195 2.60933 11.0076 2.49738 11.0076H2.38542C2.38542 11.0076 2.38542 11.0076 2.27347 11.0076C2.16152 11.1195 2.04956 11.2315 2.04956 11.3434L1.04198 13.8064C0.930029 14.0303 1.04198 14.3662 1.37784 14.4781C1.60175 14.5901 1.93761 14.4781 2.04956 14.1423L2.49738 12.9108C3.1691 14.4781 4.17668 15.8216 5.74402 16.7172C7.64723 17.8367 9.77434 18.2845 11.9015 17.7248C14.9242 17.053 17.2752 14.702 17.9469 11.6793C18.0589 11.4554 17.835 11.2315 17.6111 11.1195Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='0.3'
        />
      </motion.svg>
    </StyleRefreshIcon>
  );
};

export default RefreshIcon;
